const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');
const storage = require('utilities/storage');

// @ utils
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const SanitizeHelper = require('utilities/sanitizeHelper')

// @actions
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');

// @ constants
const {
    BROKER_WARRANTS_RESULTS_ROWS_CALL_TYPE_ID,
    BROKER_WARRANTS_RESULTS_ROWS_PUT_TYPE_ID,
    DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT,
    PRODUCT_TYPE_WARRANTS,
} = require('constants/index');

class BrokerAdvancedSearchWarrantsResultsRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    componentWillUnmount() {
        storage.localStorage.set(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, 1);
    }

    buildCallPutText(typeId) {
        switch (typeId) {
            case BROKER_WARRANTS_RESULTS_ROWS_CALL_TYPE_ID:
                return formatText('broker-searchResultsCall');
            case BROKER_WARRANTS_RESULTS_ROWS_PUT_TYPE_ID:
                return formatText('broker-searchResultsPut');
            default:
                return formatText('broker-searchResultsNotAvailableData');
        }
    }

    handleProductSelect() {
        const { item } = this.props;
        const product = {
            id: {
                isin: item.get('instrumentId'),
                iso: item.get('micCode')
            },
            label: item.get('instrument')
        };

        this.props.onHandleProductSelect(product);
    }

    render() {
        const { item, immStocksContracts, rowIndex, showModal, watchlistEnabled } = this.props;

        const notAvailableText = formatText('broker-searchResultsNotAvailableData');
        const buyLabel = watchlistEnabled ? formatText(`broker-searchResultsWatchListBuyLabel`) : formatText(`broker-searchResultsBuyLabel`);
        const buyButtonSize = watchlistEnabled ? "compact" : "regular";

        const instrument = item.get('instrument');
        const instrumentId = item.get('instrumentId');
        const micCode = item.get('micCode');
        const productDescription = item.get('productDescription');
        const underlyingInstrument = item.get('underlyingInstrument');
        const strikePrice = formatAmount(item.get('strikePrice'), getLanguage(), 3);
        const issuerName = item.get('issuerName');
        const madurityDate = item.get('madurityDate');
        const typeId = item.get('typeId');
        const callPutText = this.buildCallPutText(typeId);

        const buyUrl = `/myprofile/broker/warrantsBuy/${instrumentId}/${micCode}`;
        const warrantFileUrl = `/myprofile/broker/warrantsProductFile/${instrumentId}/${micCode}`;
        const buttonText = 'Seleccionar';
        const watchlistId = item.get('watchlistId');
        const productKey = item.get('productKey');
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });
        const emptyContracts = immStocksContracts.isEmpty();
        let button;
        if (this.props.isModal) {
            button = (
                <OKButton modifier="secondary" onClick={this.handleProductSelect}>
                    {buttonText}
                </OKButton>
            );
        } else {
            if (emptyContracts) {
                button = (<OKButton modifier="secondary" onClick={showModal}>
                    {buyLabel}
                </OKButton>);
            } else {
                button = (
                    <BrokerMiFIDUSPersonButton
                        modifier="secondary"
                        onClick={() => this.props.onBuyClick(buyUrl)}
                        size={buyButtonSize}
                        isinId={instrumentId}
                        marketId={micCode}
                        >
                        {buyLabel}
                    </BrokerMiFIDUSPersonButton>
                );
            }
        }

        const watchlistButton = (
            <span>
                <OKButton
                    modifier="ghost"
                    size="small"
                    autoHeight={true}
                    onClick={() => { !watchlistId ? this.props.onWatchlistClick(instrumentId, micCode, PRODUCT_TYPE_WARRANTS, productKey) : this.props.deleteProductFromList(watchlistId, instrumentId, micCode, instrument, watchlistId, false, PRODUCT_TYPE_WARRANTS, productKey)}}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );
        const watchListToolTipInitialVal = Number(storage.localStorage.get(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT)) === 0;
        const isTooltipVisible = (rowIndex == 0 && watchListToolTipInitialVal && watchlistEnabled);
        const watchlistBtnTooltip = watchlistEnabled && (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                isVisible={isTooltipVisible}
            />
        );

        return (
            <OKTableRow>
                <OKTableCell
                    className="broker-search-results__table-cell broker-search-results__table-first-column broker-search-results__table-cell--bold"
                >
                    <OKLink to={warrantFileUrl}>
                        {SanitizeHelper.sanitizeData(instrument)}
                    </OKLink>
                </OKTableCell>
                <OKTableCell>
                    {productDescription}
                </OKTableCell>
                <OKTableCell>
                    {underlyingInstrument || notAvailableText}
                </OKTableCell>
                <OKTableCell className="broker-search-results__table-cell--capitalize broker-search-results__table-cell--left-padding">
                    {callPutText}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-cell--warrants-price"
                >
                    {strikePrice || notAvailableText}
                </OKTableCell>
                <OKTableCell alignment="center">
                    {issuerName}
                </OKTableCell>
                <OKTableCell alignment="center">
                    {madurityDate}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-cell--action"
                >
                    <div className="broker-search-results__action-group">
                        {watchlistBtnTooltip}
                        {button}
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

BrokerAdvancedSearchWarrantsResultsRow.propTypes = {
    item: PropTypes.object,
    isModal: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    onBuyClick: PropTypes.func,
    selectedType: PropTypes.string,
    onWatchlistClick: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    immStocksContracts: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    rowIndex: PropTypes.number,
    watchlistEnabled: PropTypes.bool
};

module.exports = {
    constructor: BrokerAdvancedSearchWarrantsResultsRow,
    BrokerAdvancedSearchWarrantsResultsRow: connect(
        state => ({
            immStocksContracts: state.brokerStocksContract
        }),{
            showModal: brokerNoStockAccountModalActions.showModal,
        })(BrokerAdvancedSearchWarrantsResultsRow)
};


